
import axios from 'axios';
import { getAuthToken } from '../utils/authUtils';

const API_BASE = process.env.REACT_APP_FIREBASE_BACKEND_API_BASE || 'https://quantumleap-emr-dev.web.app';



export class AuditService {
  static async getClockEvents(startDate, endDate, limitCount = 500) {
    try {
      const token = await getAuthToken();
      const params = new URLSearchParams({
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString(),
        limit: limitCount.toString()
      });

      const response = await axios.get(
        `${API_BASE}/admin/audit/clock-events?${params.toString()}`,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      
      return response.data.events || [];
    } catch (error) {
      console.error('Error fetching clock events:', error);
      throw error;
    }
  }

  static async getAuditLogs(startDate, endDate, limitCount = 500) {
    try {
      const token = await getAuthToken();
      const params = new URLSearchParams({
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString(),
        limit: limitCount.toString()
      });

      const response = await axios.get(
        `${API_BASE}/admin/audit/logs?${params.toString()}`,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      
      return response.data.logs || [];
    } catch (error) {
      console.error('Error fetching audit logs:', error);
      throw error;
    }
  }

  static async getFacilities() {
    try {
      const token = await getAuthToken();
      const response = await axios.get(
        `${API_BASE}/facility/facilities`,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      
      return response.data.facilities || [];
    } catch (error) {
      console.error('Error fetching facilities:', error);
      throw error;
    }
  }

  static generateClockEventsSummary(clockEvents) {
    if (!Array.isArray(clockEvents) || clockEvents.length === 0) {
      return {
        totalClockIns: 0,
        totalClockOuts: 0,
        overdueClockOuts: 0,
        managerOverrides: 0,
        overtimeEvents: 0,
        totalEvents: 0
      };
    }

    const summary = clockEvents.reduce((acc, event) => {
      acc.totalEvents++;
      
      if (event.action === 'clock_in') {
        acc.totalClockIns++;
      } else if (event.action === 'clock_out') {
        acc.totalClockOuts++;
      }
      
      if (event.managerOverride === true) {
        acc.managerOverrides++;
      }
      
      if (typeof event.overtimeHours === 'number' && event.overtimeHours > 0) {
        acc.overtimeEvents++;
      }
      
      return acc;
    }, {
      totalClockIns: 0,
      totalClockOuts: 0,
      overdueClockOuts: 0,
      managerOverrides: 0,
      overtimeEvents: 0,
      totalEvents: 0
    });

    // Calculate overdue clock outs (users who clocked in but haven't clocked out)
    const clockIns = clockEvents.filter(e => e.action === 'clock_in');
    const clockOuts = clockEvents.filter(e => e.action === 'clock_out');
    
    summary.overdueClockOuts = clockIns.filter(clockIn => {
      // Check if there's a corresponding clock out after this clock in
      const hasClockOut = clockOuts.some(clockOut => 
        clockOut.userId === clockIn.userId && 
        clockOut.timestamp > clockIn.timestamp
      );
      return !hasClockOut;
    }).length;

    return summary;
  }
}
